import { toast } from 'react-toastify';
import { API_ENDPOINT } from 'services/api'

export async function apiRequest(callApi) {
    const response = await callApi()

    const status = response?.error?.status

    if (status === 401) {
        return response
    }

    if (status === 403) {
        toast.error("You don't have permission to access this resource.")
        return response
    }

    return response
}

export const exposeStrapiError = result => {

    if (!result) {
        toast.error('Cant connect to server, try again later')
        return true;
    }

    if (result?.error && result?.data?.[0]?.messages?.[0]?.message && typeof result?.data?.[0]?.messages?.[0]?.message === 'string') {
        toast.error(result?.data?.[0]?.messages?.[0]?.message)
        return true;
    } else if (result?.error && result?.message?.[0]?.messages?.[0]?.message && typeof result?.message?.[0]?.messages?.[0]?.message === 'string') {
        toast.error(result?.message?.[0]?.messages?.[0]?.message)
        return true;
    } else if (result?.error && result?.data?.[0]?.message && typeof result?.data?.[0]?.message === 'string') {
        toast.error(result?.data?.[0]?.message)
        return true;
    } else if (result?.error && result?.message && typeof result?.message === 'string') {
        toast.error(result?.message)
        return true;
    } else if (result?.error && result?.error?.message && typeof result?.error?.message === 'string') {
        toast.error(result?.error?.message)
        return true;
    }

    if (result?.error && result?.error?.details?.errors?.length) {
        result?.error?.details?.errors?.map(item => {
            toast.error(item?.message)
            return true;
        })
        return true;
    }

    return false;
}

export const normalizeStrapiList = result => {
    return result?.data?.length ? result?.data.map(item => ({
        id: item.id,
        ...item.attributes
    })) : []
}

export const normalizeStrapiRegisterSolo = result => {
    return result?.id && result?.attributes ? {
        id: result?.id,
        ...result?.attributes
    } : result?.data?.id ? result?.data?.attributes ? {
        id: result?.data?.id,
        ...result?.data?.attributes
    } : result?.data : result
}

export const normalizeStrapiRegister = result => {
    if (!result?.data) return null;
    let results = normalizeStrapiRegisterSolo(result)
    Object.keys(results).map(attrKey => {
        results[attrKey] = results[attrKey]?.data ? normalizeStrapiRegisterSolo(results[attrKey]) : results[attrKey]
        results[attrKey] = typeof results[attrKey]?.data === 'object' ? results[attrKey]?.data : results[attrKey]
        results[attrKey] = results[attrKey]?.length && results[attrKey]?.[0]?.attributes ?
            results[attrKey]?.map(normalizeStrapiRegisterSolo)
            : results[attrKey]


        return true;
    })
    return results;
}

export const normalizeStrapiPayload = (form, formtypes) => {

    formtypes.map(item => {
        if (form[item.name]) {
            if ((item.type === 'float' || item.type === 'decimal') && item.name === 'price' && typeof form[item.name] === 'string') {
                form[item.name] = parseFloat(form[item.name].replace(/R|\$|\.| /g, '').replace(',', '.'))
            }

            if (item.type === 'float' || item.type === 'decimal') {
                form[item.name] = parseFloat(form[item.name])
            }

            if (item.type === 'biginteger' || item.type === 'integer') {
                form[item.name] = parseInt(form[item.name])
            }

            if ((item.type === 'date' || item.type === 'time' || item.type === 'datetime') && typeof form[item.name]?.getFullYear === 'function') {
                form[item.name] = parseStrapiDate(form[item.name])
            }

            if (item.type === 'time') {
                form[item.name] = (`${form[item.name]}`.split("T")).pop()
            }

            if (item.type === 'date') {
                form[item.name] = `${(`${form[item.name]}`.split("T")).shift()}`
            }

        }
        return true;
    })

    return { ...form, data: { ...form } }
}

export const numerize = number => {
    return parseInt(number) < 10 ? `0${number}` : `${number}`
}

export const parseStrapiDate = date => {
    return typeof date?.getFullYear !== 'function' ? date : `${date.getFullYear()}-${numerize(date?.getMonth() + 1)}-${numerize(date?.getDate())}T${numerize(date?.getHours())}:${numerize(date?.getMinutes())}:${numerize(date?.getSeconds())}`
}

export const pickFirstMedia = (media) => {
    if (!media) return null;

    // If already a normalized object with url (result of normalizeStrapiRegister* or direct /upload response)
    if (media?.url || media?.formats) return media;

    // Strapi v4 relation shape
    const d = media?.data;

    if (Array.isArray(d)) {
        const first = d[0];
        if (!first) return null;
        // If it already has attributes (standard CT media rel)
        if (first?.attributes) {
            return { id: first.id, ...first.attributes };
        }
        // Fallback to existing normalizer in case of different shape
        return normalizeStrapiRegisterSolo(first);
    }

    if (d && d?.attributes) {
        return { id: d.id, ...d.attributes };
    }

    // Fallback: try to normalize whatever shape came in
    return normalizeStrapiRegister(media);
}

export const parseStrapiImage = url => {
    return url?.indexOf('://') !== -1 ? url : `${API_ENDPOINT.replace('/api', '')}${url}`
}

export const MODULAR_CONTENT_TYPES = ['courses', 'partners-and-staffs']

export const isModularContentType = type => MODULAR_CONTENT_TYPES.includes(type)

export const normalizeRawCategory = (rc) => {
    if (!rc) return [];
    const items = Array.isArray(rc) ? rc : (rc?.data && Array.isArray(rc.data) ? rc.data : [rc]);
    return items.map(it => ({
        id: it?.id || it?.attributes?.id,
        title: it?.title || it?.attributes?.title || it?.attributes?.name,
        type: it?.type || undefined,
    }));
};

export const findShowableParam = item => {

    const notAllowed = [
        'id',
        'createdAt',
        'updatedAt',
        'createdBy',
        'updatedBy',
        'publishedAt',
        'attributes',
        'created_by',
        'updated_by',
        'created_at',
        'updated_at',
        'published_by',
        'published_at',
    ]
    return Object.keys(item).filter(fit => !notAllowed.includes(fit)).shift()
}

export const filterSystemParams = (fit, attrs, item) => {

    const notAllowed = [
        'id',
        'createdAt',
        'updatedAt',
        'createdBy',
        'updatedBy',
        'publishedAt',
        'created_by',
        'updated_by',
        'created_at',
        'updated_at',
        'published_by',
        'published_at',
    ]

    if (item.uid.indexOf('plugin::') !== -1) {
        notAllowed.push('provider')
        notAllowed.push('role')
    }

    return !notAllowed.includes(fit) && (!attrs.private || attrs.type === 'password')
}

export const capitalize = (s) => {
    if (!s) { return ``; }
    let vs = `${s}`
    return `${vs.charAt(0).toUpperCase()}${vs.slice(1)}`;
}


export const objectToQueryString = (obj, parentKey = '') => {
    let queryString = '';

    Object.keys(obj).forEach(key => {
        const fullKey = parentKey ? `${parentKey}[${key}]` : key;

        if (Array.isArray(obj[key])) {
            obj[key].forEach((value, index) => {
                queryString += `${fullKey}[${index}]=${value}&`;
            });
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
            queryString += objectToQueryString(obj[key], fullKey);
        } else {
            queryString += `${fullKey}=${obj[key]}&`;
        }
    });

    if (queryString.endsWith('&')) {
        queryString = queryString.slice(0, -1);
    }

    return queryString;
}

export const scrollToSection = (id) => {
    if (!id) return;
    const headerHeight = 73
    const sectionTop = document.getElementById(id)?.offsetTop;
    if (sectionTop) { window.scrollTo({ top: sectionTop - headerHeight, behavior: 'smooth' }); }
}

const sanitizeHtmlFallback = (rawHtml) => {
    return `${rawHtml}`
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
        .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '')
        .replace(/\son\w+\s*=\s*(['"]).*?\1/gi, '')
        .replace(/\son\w+\s*=\s*[^ >]*/gi, '')
        .replace(/\s(href|src)\s*=\s*(['"])\s*javascript:[^'"]*\2/gi, '')
        .replace(/\s(href|src)\s*=\s*javascript:[^ >]*/gi, '')
}

export const parseCustomFieldHtml = (content) => {
    if (!content) return { __html: '' }

    const rawHtml = `${content}`

    if (typeof window === 'undefined' || typeof window.DOMParser === 'undefined') {
        return { __html: sanitizeHtmlFallback(rawHtml) }
    }

    const parser = new window.DOMParser()
    const doc = parser.parseFromString(rawHtml, 'text/html')

    doc.querySelectorAll('script, style, iframe, object, embed').forEach(node => node.remove())

    doc.querySelectorAll('*').forEach(node => {
        Array.from(node.attributes || []).forEach(attr => {
            const attrName = `${attr.name || ''}`.toLowerCase()
            const attrValue = `${attr.value || ''}`.trim()

            if (attrName.startsWith('on')) {
                node.removeAttribute(attr.name)
                return
            }

            if (['href', 'src', 'xlink:href'].includes(attrName) && /^javascript:/i.test(attrValue)) {
                node.removeAttribute(attr.name)
            }
        })
    })

    doc.querySelectorAll('a[target="_blank"]').forEach(link => {
        const relList = `${link.getAttribute('rel') || ''}`
            .split(/\s+/)
            .filter(Boolean)
        const relSet = new Set(relList)
        relSet.add('noopener')
        relSet.add('noreferrer')
        link.setAttribute('rel', Array.from(relSet).join(' '))
    })

    return { __html: doc.body.innerHTML }
}
